import React from 'react';
import {Carousel, Container} from 'react-bootstrap';
import {Redirect, useParams} from 'react-router-dom';

import {convertCasing, casings} from '@nick-bull/convert-casing';

import {articleService} from '#services/articleService';

import {withPage} from '#pages';
import {Header} from '#components/header';
import Gantt from '#components/gantt/Gantt';

import {mediaErrors} from '#errors/media';

import './article.css';

const articles = articleService.getArticles();

const mediaTypes = {
  video: 'video',
  image: 'image',
};
const getMediaComponent = ({type, ...medium}) => {
  switch (type) {
    case mediaTypes.image:
      return <ArticleImage {...medium} />
    case mediaTypes.video:
      return <ArticleVideo {...medium} />
  }

  throw new Error(mediaErrors.invalidType);
};
const ArticleVideo = ({path, format}) => (
  <video className="article--carousel-video" controls>
    <source src={path} type={`video/${format}`} />
  </video>
);
const ArticleImage = ({path}) => (
  <img className="article--carousel-image" src={path} />
);
const ArticleMedium = ({medium, ...props}) => {
  const {description} = medium;

  return (
    <Carousel.Item className="article--carousel-item" {...props}>
      {getMediaComponent(medium)}
  
      <Carousel.Caption {...props}>
        {description}
      </Carousel.Caption>
    </Carousel.Item>
  );
};

const createArticleMedium = (medium, index) => (
  <ArticleMedium key={index} medium={medium} />
);
const sectionToComponent = (section) => {
  const {name, value} = section;

  if (name === 'media') {
    return (
      <Carousel className="article--carousel">
        {value.map(createArticleMedium)}
      </Carousel>
    );
  }

  return (typeof value === 'string') ? <p>{value}</p> : value;
};
const createArticleSection = (section) => {
  const {name} = section;
  const sectionComponent = sectionToComponent(section);

  return (
    <div className="article--section">
      <h2>{name}</h2>
      <hr />
      {sectionComponent}
    </div>
  );
};
export const Article = withPage(() => {
  const {slug} = useParams();
  const id = convertCasing(slug, casings.kebab, casings.camel);

  const article = articles[id];
  if (article === undefined) {
    return <Redirect to="/404" />;
  }

  const articleName = convertCasing(slug, casings.kebab, casings.proper);
  const {thumbnail, ...articleData} = article;

  const articleEntries = Object.entries(articleData);
  const articleSections = articleEntries.map(([name, value]) => (
    createArticleSection({name, value})
  ));

  return (
    <Container>
      <Header title={articleName} />

      {articleSections}
    </Container>
  );
});
